import { useState, useEffect } from 'react';

export function useTooltipWithScrollClose(): [boolean, (next: boolean) => void] {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!show) return;
    const handleScroll = () => setShow(false);
    window.addEventListener('scroll', handleScroll, true);
    return () => window.removeEventListener('scroll', handleScroll, true);
  }, [show]);

  return [show, setShow];
}
